import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import PrintExcessBaggageTicketButton from './PrintExcessBaggageTicketButton';
import PrintItemsStickerButton from './PrintItemsStickerButton';
import PrintBaggageTicketButton from './PrintBaggageTicketButton';
import BaggageVoidButton from './ExcessBaggageVoidButton';
import BaggageCreditNoteButton from './BaggageCreditNoteButton';
import PinPadVoucherButtons from '../../../common/button/PinPadVoucherButtons';
import { PIN_PAD_TRANSACTION_SOURCE_TYPE } from '../../../../config/constants';

const BaggageToolbar = ({ baggageId, baggage, voided }) => (
  <ButtonToolbar className="pull-right">
    <div>
      {!voided && (
        <>
          <PrintExcessBaggageTicketButton />{' '}
          <PrintBaggageTicketButton baggage={baggage} />{' '}
          <PrintItemsStickerButton baggage={baggage} />{' '}
          {/* <EditBaggageButton baggageId={baggageId} />{' '} */}
          {/* <DeleteBaggageButton
            baggageId={baggageId}
            containtExcessBaggage={containtExcessBaggage}
          /> */}
          <BaggageVoidButton baggageId={baggageId} />{' '}
          {baggage.excessBaggage && (
            <>
              <BaggageCreditNoteButton
                baggageId={baggageId}
                baggage={baggage}
              />{' '}
            </>
          )}
        </>
      )}
      <PinPadVoucherButtons
        sourceType={PIN_PAD_TRANSACTION_SOURCE_TYPE.EXCESS_BAGGAGE}
        sourceId={baggageId}
      />
    </div>
  </ButtonToolbar>
);

BaggageToolbar.propTypes = {
  baggageId: PropTypes.number.isRequired,
  voided: PropTypes.bool,
  baggage: PropTypes.shape({
    id: PropTypes.number,
    excessBaggage: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
};

BaggageToolbar.defaultProps = {
  baggage: null,
  voided: false,
};

export default BaggageToolbar;
